import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon, SearchIcon, WrenchIcon, WindIcon } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Personas que sienten que su hogar "les pesa" o las agota.', 'Emprendedores que necesitan enfoque y claridad mental en su espacio.', 'Parejas que buscan recuperar la armonía y el equilibrio en su dormitorio.', 'Cualquier persona que quiera vivir mejor en la casa que ya tiene.'];
  const isNotFor = ['Personas que buscan soluciones mágicas sin mover un solo mueble.', 'Quienes prefieren la estética por encima de la funcionalidad y la salud energética.'];
  const steps = [{
    title: 'Identifica',
    description: 'Detecta los "puntos ciegos" de tu casa usando mis mapas visuales.',
    icon: SearchIcon
  }, {
    title: 'Ajusta',
    description: 'Aplica los micro-cambios (sin gastar en reformas ni muebles nuevos).',
    icon: WrenchIcon
  }, {
    title: 'Fluye',
    description: 'Observa cómo mejora tu descanso, tu claridad y tu flujo de ingresos.',
    icon: WindIcon
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-cream relative" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        {/* Who this is for / not for */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-24" data-id="element-3">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-2xl p-8 sm:p-10 shadow-sm border border-sage/10" data-id="element-4">
            <h3 className="text-2xl sm:text-3xl font-serif text-charcoal mb-8" data-id="element-5">
              Para quién es esto
            </h3>
            <ul className="space-y-6" data-id="element-6">
              {isFor.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-7">
                  <CheckCircleIcon className="w-6 h-6 text-sage flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-8" />
                  <span className="ml-4 text-charcoal/80 text-lg" data-id="element-9">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white/50 rounded-2xl p-8 sm:p-10 border border-terracotta/10" data-id="element-10">
            <h3 className="text-xl sm:text-2xl font-serif text-charcoal/60 mb-8" data-id="element-11">
              Para quién NO es esto
            </h3>
            <ul className="space-y-6" data-id="element-12">
              {isNotFor.map((item, idx) => <li key={idx} className="flex items-start opacity-80" data-id="element-13">
                  <XCircleIcon className="w-6 h-6 text-terracotta/70 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-14" />
                  <span className="ml-4 text-charcoal/70 text-lg" data-id="element-15">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* How it works */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl sm:text-4xl font-serif text-charcoal mb-4" data-id="element-17">
            Cómo funciona
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-18"></div>
        </motion.div>

        <div className="relative" data-id="element-19">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gold/20 z-0" data-id="element-20"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-21">
            {steps.map((step, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-22">
                <div className="w-24 h-24 rounded-full bg-white shadow-warm flex items-center justify-center mb-6 relative border-2 border-gold/20" data-id="element-23">
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gold text-white flex items-center justify-center font-bold text-sm shadow-sm" data-id="element-24">
                    {idx + 1}
                  </div>
                  <step.icon className="w-10 h-10 text-sage" aria-hidden="true" data-id="element-25" />
                </div>
                <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-26">
                  {step.title}
                </h3>
                <p className="text-charcoal/70 text-lg leading-relaxed max-w-xs" data-id="element-27">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}